import { CModalBody } from "@coreui/react"

import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material"

import { Typography } from "@mui/material"

export const HowToDataSteps = [
	{
		label: "¿Dónde? (bajo el agua, obviamente)",
		description: (
			<CModalBody>
				<Typography>
					Si quieres jugar al hockey, puedes hacerlo donde quieras y te
					apetezca, mientras os podáis sumergir un poco y hacer que el disco se
					deslice, siempre es un buen momento para jugar.
				</Typography>
				<Typography>
					Pero si lo que queréis es conocer qué se considera un campo oficial,
					os compartimos las reglas que establece la CMAS:
				</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							El área de juego será una piscina o parte de ella (la CMAS
							descarta bañeras, jacuzzis, bidones, embalses o el fondo del mar)
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							El área de juego deberá tener una anchura de 12m a 15m
							(aproximadamente unas 6-8 calles de natación) y una longitud de
							21m a 25m (esto es lo que se conoce como una piscina
							semiolímpica), siempre que la superficie mínima de juego sea de
							300 metros cuadrados.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							El área de juego será una piscina o parte de ella (la CMAS
							descarta bañeras, jacuzzis, bidones, embalses o el fondo del mar)
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							El fondo de la piscina debe ser plano o tener una pendiente suave,
							con una inclinación máxima de 1 a 20. Aunque a veces en algunos
							torneos esto no es tan perfecto. ¿Sabíais que en Toulousse se
							hacía un torneo con un campo que estaba prácticamente a 30º de
							inclinación?
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							La profundidad del agua deberá estar comprendida entre 2m y 3,65m,
							aunque de nuevo aquí podemos encontrar algunas piscinas de algo
							menos de profundidad en las que se juegan torneos, de más de 3,65m
							es algo difícil y sobre todo aumenta bastante la dureza de un
							partido.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Las líneas de fondo deben ser de naturaleza sólida, es decir, las
							paredes de la piscina. Es decir, donde se encuentran las
							porterías, debe haber una pared, no vale que suceda como en el
							hockey hielo.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Una línea lateral puede ser una pared de la piscina, una barrera
							sólida o una línea de demarcación en el fondo de la piscina, de
							una altura mínima de 300 mm. Aquí de nuevo hay que diferenciar que
							para los Campeonatos Mundiales, son esenciales las barreras o
							muros resistentes, pero en otros torneos se marca la línea lateral
							como se pueda.
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>
		),
	},
	{
		label: "¿Durante cuánto?",
		description: (
			<CModalBody>
				<Typography>
					Un partido oficial, de los internacionales, 33 minutos, bueno, en
					realidad dura 30, pero se cuenta con que el partido se divide en dos
					partes de 15 minutos con un descanso de 3 minutos entre ellos.
				</Typography>
				<Typography>
					Durante el descanso, los equipos cambiarán de lado. Esto es
					especialmente importante si la piscina tiene un lado más profundo que
					el otro por ejemplo.
				</Typography>
				<Typography>
					Una vez iniciado, el tiempo corre, y no se detiene hasta los 2 últimos
					minutos de un partido y sólo puede ser detenido por el árbitro
					principal en caso de lesión grave, para consultar algo especial, y
					algunos casos muy concretos.
				</Typography>
			</CModalBody>
		),
	},
	{
		label: "¿Con quién?",
		description: (
			<CModalBody>
				<Typography>
					La modalidad clásica, recogida por la CMAS, es la de 6 jugadores en el
					agua, y 4 cambios que se pueden hacer en cualquier momento. Para un
					torneo se puede llevar hasta a 12 jugadores, pero a cada partido solo
					pueden ser convocados 10.
				</Typography>
				<Typography>
					Para explicar la forma más sencilla de jugar, os contaremos que cada
					equipo suele (y decimos suele, porque esto requiere un capítulo a
					parte) estar formado por 3 jugadores que juegan en una posición de
					ataque, y 3 jugadores que juegan en una posición de defensa, con esta
					distribución:
				</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>2 atacantes o delanteros</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>1 centro</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>2 defensas o alas</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>1 portero</ListItemText>
					</ListItem>
				</List>
				<Typography>
					La idea es que los jugadores tengan un área de la zona donde se está
					jugando el disco asignada, y puedan cubrir el mayor volumen de campo
					posible.
				</Typography>
				<Typography>
					Y si sois menos, podéis adaptar el equipo a lo que creáis más
					conveniente. Hay algunos torneos donde se juega 3 vs 3 por ejemplo, y
					las posiciones en ese caso son más relativas.
				</Typography>
			</CModalBody>
		),
	},
	{
		label: "¿A qué?",
		description: (
			<CModalBody>
				<Typography>
					Esto es lo más fácil de explicar, no es quidditch: se juega a meter
					goles, y al final del partido, el equipo que haya marcado más goles,
					será declarado ganador.
				</Typography>
				<Typography>
					Si ambos equipos han marcado el mismo número de goles, el partido
					termina en empate. Y si se trata de una eliminatoria, y el partido no
					se puede empatar, lo que se hace es jugar una prórroga de 10, dividida
					en 2 partes de 5, cambiando de campo incluso.
				</Typography>
			</CModalBody>
		),
	},
	{
		label: "¿Y necesito un árbitro?",
		description: (
			<CModalBody>
				<Typography>
					De igual manera que para jugar un partidito de fútbol con tus amigos o
					un partido de pádel, no traes a un amigo para que haga de árbitro, al
					hockey, normalmente tampoco. Las faltas en los entrenamientos o cuando
					nos juntamos para jugar se pitan entre los jugadores, y todo el mundo
					intenta respetar lo que se ha pitado. En el caso de que haya un
					entrenador en el agua, suele ser él quien pita las faltas.
				</Typography>
				<Typography>
					Para conocer más detalles de lo que se puede hacer y lo que no,
					dejaremos un apartado con las reglas y las faltas para que las podáis
					conocer en profundidad más adelante.
				</Typography>
			</CModalBody>
		),
	},
]
